export class DeviceModel {
    Id: number;
    CategoryId: number;
    IconName: string;
    MobileRemotes: boolean;
    LocalInputs: number;
    LocalOutputs: number;
    MaxAutomations: number;
    MaxSubGateways: number;
    AvailableServices: number[];
    SignalLevel?: boolean;
    BoardName?: string;
    BoardClass?: number;
    BoardId?: number;
    BoardInputs?: number;
    BoardOutputs?: number;
    CategoryName: string;
    Description: string;
    ProductName: string;
    ProductBoardName: string;
    Sharable: boolean;
    Vpn: boolean;
}

export class NewDeviceModel {
    Id?: number;
    CategoryId?: number;
    IconName?: string;
    ProductName?: string;
    Description?: string;
    Vpn?: boolean;
    SignalLevel?: boolean;
    Sharable?: boolean;
    MobileRemotes?: boolean;
    LocalInputs?: number;
    LocalOutputs?: number;
    MaxAutomations?: number;
    MaxSubGateways?: number;
    BoardClass?: number;
    BoardId?: number;
    BoardName?: string;
    BoardProductName?: string;
    BoardProductCode?: string;
    BoardPower?: string;
    BoardDescription?: string;
    BoardInputs?: number;
    BoardOutputs?: number;
    MotorProductCode?: string;
    MotorPower?: string;
    MotorDescription?: string;
    SeriesName?: string;
    AutomationTypeName?: string;
}
